import React, { useState, useEffect } from "react";
import { FiChevronDown, FiGlobe } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { ContextMenu, ContextMenuItem, InputField, Modal, ModalBody, ModalButton, ModalFooter, Spinner } from "../Components/Components";
import Logo from "../img/logo.png";

import SAFM from "../libs/Safm";
import config from "../config.json";

const Login = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const [companies, setCompanies] = useState([]);
  const [companyDomain, setCompanyDomain] = useState();
  const [newCompany, setNewCompany] = useState("");

  const [showCompanies, setShowCompanies] = useState(false);
  const [showSetupModal, setShowSetupModal] = useState(false);

  useEffect(() => {
    document.title = "SAFM | Login";

    if (window.localStorage.getItem("companies")) {
      setCompanyDomain(window.localStorage.getItem("companyDomain"));
      setCompanies(JSON.parse(window.localStorage.getItem("companies")));
    } else {
      if (!!config.companies) {
        window.localStorage.setItem("companyDomain", config.companies[0]);
        window.localStorage.setItem("companies", JSON.stringify(config.companies));

        window.location.reload();
      } else {
        setShowSetupModal(true);
      }
    }

    const userCode = window.localStorage.getItem(`safm-usercode-${window.localStorage.getItem("companyDomain")}`);
    const userPassword = window.localStorage.getItem(`safm-password-${window.localStorage.getItem("companyDomain")}`);

    if (userCode) {
      setRememberMe(true);

      setUser(userCode);
      setPassword(userPassword);
    }
  }, []);

  const login = async () => {
    setLoading(true);

    window.localStorage.removeItem(`domains-${window.localStorage.getItem("companyDomain")}`); //reset domains

    const response = await SAFM.checkLogin(user, password);

    if (response === "setup") {
      setShowSetupModal(true);
      setLoading(false);
      return false;
    }

    if (response === "error") {
      setLoginError("Errore autenticazione");
      setLoading(false);
      return false;
    }

    setLoginError(null);
    navigate(response);

    if (rememberMe) {
      window.localStorage.setItem(`safm-usercode-${window.localStorage.getItem("companyDomain")}`, user);
      window.localStorage.setItem(`safm-password-${window.localStorage.getItem("companyDomain")}`, password);
    } else {
      window.localStorage.removeItem(`safm-usercode-${window.localStorage.getItem("companyDomain")}`);
      window.localStorage.removeItem(`safm-password-${window.localStorage.getItem("companyDomain")}`);
    }
  };

  const addCompany = () => {
    const company = newCompany.charAt(newCompany.length - 1) !== "/" ? `${newCompany}/` : newCompany;

    if (!companies.includes(company)) {
      if (!companyDomain) {
        console.log(company);

        setCompanyDomain(company);
        window.localStorage.setItem("companyDomain", company);
      }
      setCompanies((companies) => [...companies, company]);
    }

    setNewCompany("");
  };

  const removeCompany = (company) => {
    setCompanies((companies) => companies.filter((item) => item.toLowerCase() !== company.toLowerCase()));
  };

  const saveSetup = () => {
    window.localStorage.setItem("companies", JSON.stringify(companies));
    window.location.reload();
  };

  return (
    <div className='flex h-screen text-black dark:text-white dark:bg-black'>
      <div className='animate-fade-in-slow'>
        <div className='fixed top-0 left-0 w-full h-8' style={{ WebkitAppRegion: "drag" }}></div>
        <div className='fixed text-sm top-8 left-0 w-full h-10 flex justify-end items-center px-6 box-border'>
          {companies.length === 0 && (
            <a className='flex items-center cursor-pointer select-none' onClick={() => setShowSetupModal(true)}>
              <FiGlobe className='mr-1' />
              Modifica domini
            </a>
          )}
          {companies.length > 0 && (
            <a className='flex items-center cursor-pointer select-none' onClick={() => setShowCompanies(!showCompanies)}>
              <FiGlobe className='mr-1' />
              {companyDomain.replace("https://", "")}
              <FiChevronDown className='ml-1' />
            </a>
          )}

          {companies.length > 0 && showCompanies && (
            <ContextMenu top={56}>
              {companies.map((company) => {
                return (
                  <ContextMenuItem
                    key={company}
                    onClick={() => {
                      window.localStorage.setItem("companyDomain", company);
                      window.location.reload();
                    }}>
                    {company}
                  </ContextMenuItem>
                );
              })}
              <ContextMenuItem
                key={0}
                onClick={() => {
                  setShowSetupModal(true);
                  setShowCompanies(false);
                }}>
                Modifica domini
              </ContextMenuItem>
            </ContextMenu>
          )}
        </div>
        <div className='w-screen flex flex-col flex-1 items-center'>
          <div className='flex flex-col items-center justify-center pointer-events-none mt-32 mb-16'>
            <img style={{ width: 96 }} src={Logo} />
          </div>

          <InputField full={false} placeholder='Codice utente' value={user} onChange={({ target }) => setUser(target.value)} />
          <InputField
            full={false}
            placeholder='Password'
            value={password}
            type='password'
            onKeyPress={(e) => (e.key === "Enter" ? login() : null)}
            onChange={({ target }) => setPassword(target.value)}
          />

          <div className='relative flex items-center justify-end items-center w-96 px-1'>
            <input className='relative mr-2' onChange={({ target }) => setRememberMe(target.checked)} checked={rememberMe} type='checkbox'></input>
            <label className='text-sm text-black-700 dark:text-black-400'>Ricordami</label>
          </div>

          {loginError !== null && <span className='font-semibold text-red'>Errore di autenticazione</span>}

          <br />
          <div className='relative flex flex-col my-4 w-96'>
            {!loading && (
              <button
                type='button'
                className='h-12 text-sm text-white font-semibold rounded-lg uppercase bg-gradient-to-r from-blue to-aqua leading-[1px] active:scale-95 hover:opacity-70 transition-all'
                onClick={() => login(companyDomain)}>
                Accedi
              </button>
            )}
            {loading && (
              <button
                type='button'
                className='h-12 flex items-center justify-center text-sm text-white font-semibold rounded-lg uppercase bg-gradient-to-r from-blue to-aqua leading-[1px] cursor-wait'>
                <Spinner color='white'></Spinner>
              </button>
            )}
          </div>
        </div>
        {showSetupModal && (
          <Modal type='md' title='Lista domini'>
            <ModalBody>
              <form>
                {companies.map((item) => (
                  <div key={item} style={{ display: "flex", flex: "row", alignItems: "center" }}>
                    <InputField value={item} disabled />
                    <button className='w-8 h-8 min-w-[32px] rounded-full ml-3 bg-red text-lg text-white' onClick={() => removeCompany(item)}>
                      &times;
                    </button>
                  </div>
                ))}
                <div style={{ display: "flex", flex: "row", alignItems: "center" }}>
                  <InputField onChange={({ target }) => setNewCompany(target.value)} value={newCompany} placeholder='es. https://www.google.com/' />
                  <button type='button' className='w-8 h-8 min-w-[32px] rounded-full ml-3 bg-green text-lg text-white' onClick={addCompany}>
                    +
                  </button>
                </div>
              </form>
            </ModalBody>
            <ModalFooter>
              <ModalButton type='primary' text='Salva modifiche' onClick={saveSetup} />
              <ModalButton text='Chiudi' onClick={() => setShowSetupModal(false)} />
            </ModalFooter>
          </Modal>
        )}
      </div>
    </div>
  );
};

export default Login;
